// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insight-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.insight-section .insight-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.insight-section .insight-wrap .insight-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 2rem 2rem 0;
  margin: 0 auto;
}
.insight-section .insight-wrap .insight-box .text-box {
  width: 100%;
  max-width: 55rem;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 2rem;
}
.insight-section .insight-wrap .insight-box .text-box .para-text {
  color: var(--white-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: right;
}
.insight-section .insight-wrap .insight-box .img-box {
  width: 100%;
  max-width: 36.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.insight-section .insight-wrap .insight-box .img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
  filter: drop-shadow(0px 10px 20px var(--black-800));
  -webkit-filter: drop-shadow(0px 10px 20px var(--black-800));
  transform: scale(1.2);
  transform-origin: right center;
}
.insight-section .insight-container {
  width: 100%;
  max-width: 100rem;
  min-height: 26.5rem;
  display: flex;
  align-items: center;
  z-index: 0;
  margin: 0 auto;
  position: relative;
}
.insight-section .insight-container::before {
  content: "";
  width: 100%;
  height: 100%;
  background: linear-gradient(175deg, var(--primaryMain-1000) 4%, var(--tertiaryMain-1000) 96%);
  border-radius: 3.75rem;
  z-index: -1;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
@media screen and (max-width: 991.98px) {
  .insight-section {
    padding: 2.5rem 0;
  }
  .insight-section .insight-wrap .insight-box {
    gap: 1.5rem;
    padding: 1.5rem;
  }
  .insight-section .insight-wrap .insight-box .text-box {
    gap: 1.25rem;
  }
  .insight-section .insight-wrap .insight-box .text-box .para-text {
    font-size: 1rem;
  }
  .insight-section .insight-wrap .insight-box .img-box {
    max-width: 25rem;
  }
  .insight-section .insight-wrap .insight-box .img-box img {
    transform: scale(1);
  }
  .insight-section .insight-container {
    min-height: unset;
  }
  .insight-section .insight-container::before {
    border-radius: 1.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .insight-section {
    padding: 2rem 0;
  }
  .insight-section .insight-wrap .insight-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .insight-section .insight-wrap .insight-box .text-box {
    align-items: flex-start;
    gap: 1rem;
  }
  .insight-section .insight-wrap .insight-box .text-box .para-text {
    font-size: 0.875rem;
    text-align: left;
  }
  .insight-section .insight-wrap .insight-box .img-box {
    width: 50%;
    max-width: 25rem;
  }
  .insight-section .insight-container::before {
    border-radius: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InsightSection/InsightStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AACN;AACM;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;AACR;AACQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AACV;AAGM;EACE,WAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAGQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mDAAA;EACA,2DAAA;EACA,qBAAA;EACA,8BAAA;AADV;AAOE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AALJ;AAOI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,6FAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;AALN;AASE;EA9EF;IA+EI,iBAAA;EANF;EASI;IACE,WAAA;IACA,eAAA;EAPN;EASM;IACE,YAAA;EAPR;EASQ;IACE,eAAA;EAPV;EAWM;IACE,gBAAA;EATR;EAWQ;IACE,mBAAA;EATV;EAeE;IACE,iBAAA;EAbJ;EAeI;IACE,qBAAA;EAbN;AACF;AAiBE;EAjHF;IAkHI,eAAA;EAdF;EAiBI;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAfN;EAiBM;IACE,uBAAA;IACA,SAAA;EAfR;EAiBQ;IACE,mBAAA;IACA,gBAAA;EAfV;EAmBM;IACE,UAAA;IACA,gBAAA;EAjBR;EAuBI;IACE,mBAAA;EArBN;AACF","sourcesContent":[".insight-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .insight-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .insight-box {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 2rem 2rem 2rem 0;\n      margin: 0 auto;\n\n      .text-box {\n        width: 100%;\n        max-width: 55rem;\n        display: flex;\n        align-items: flex-end;\n        flex-direction: column;\n        gap: 2rem;\n\n        .para-text {\n          color: var(--white-1000);\n          font-size: 1.5rem;\n          font-weight: 400;\n          line-height: 1.4;\n          text-align: right;\n        }\n      }\n\n      .img-box {\n        width: 100%;\n        max-width: 36.625rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n          width: 100%;\n          max-width: 100%;\n          height: auto;\n          filter: drop-shadow(0px 10px 20px var(--black-800));\n          -webkit-filter: drop-shadow(0px 10px 20px var(--black-800));\n          transform: scale(1.2);\n          transform-origin: right center;\n        }\n      }\n    }\n  }\n\n  .insight-container {\n    width: 100%;\n    max-width: 100rem;\n    min-height: 26.5rem;\n    display: flex;\n    align-items: center;\n    z-index: 0;\n    margin: 0 auto;\n    position: relative;\n    \n    &::before {\n      content: \"\";\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(175deg, var(--primaryMain-1000) 4%, var(--tertiaryMain-1000) 96% );\n      border-radius: 3.75rem;\n      z-index: -1;\n      position: absolute;\n      top: 50%;\n      left: 0;\n      transform: translateY(-50%);\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .insight-wrap {  \n      .insight-box {  \n        gap: 1.5rem;\n        padding: 1.5rem;\n\n        .text-box {\n          gap: 1.25rem;\n  \n          .para-text {\n            font-size: 1rem;\n          }\n        }\n  \n        .img-box {\n          max-width: 25rem;\n  \n          img {\n            transform: scale(1);\n          }\n        }\n      }\n    }\n\n    .insight-container {\n      min-height: unset;\n      \n      &::before {\n        border-radius: 1.5rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .insight-wrap {  \n      .insight-box {  \n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n\n        .text-box {\n          align-items: flex-start;\n          gap: 1rem;\n  \n          .para-text {\n            font-size: 0.875rem;\n            text-align: left;\n          }\n        }\n  \n        .img-box {\n          width: 50%;\n          max-width: 25rem;\n        }\n      }\n    }\n\n    .insight-container {      \n      &::before {\n        border-radius: 1rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
